<i18n lang="yaml">
  zh:
    title: "我的作品"
    subtitle: "探索更多创作辅助工具"
    empty_tip: "Start your journey!"
    all: "全部"
    signed: "已签约"
    delete_confirm: "确定删除吗?"
    confirm: "确定"
    cancel: "取消"
    delete_signed_tip: "已签约作品不能删除"
    delete_submitted_tip: "投稿作品不能删除，请先撤回投稿"
    delete: "删除"
    no_story_name: "该故事还没有名字"
    recent_edit: "最近编辑"
    completed: "完成状态"
    search_placeholder: "输入名称搜索"
    select_story_type: "请选择故事类型"
    select_perspective: "请选择写作视角"
    menu_command_missing: "菜单选项缺少command属性"
  en:
    title: "My Work"
    subtitle: "Explore more creative tools"
    empty_tip: "Start your journey!"
    all: "All"
    signed: "Signed"
    delete_confirm: "Are you sure to delete?"
    confirm: "Confirm"
    cancel: "Cancel"
    delete_signed_tip: "Signed works cannot be deleted"
    delete_submitted_tip: "Submitted works cannot be deleted, please withdraw the submission first"
    delete: "Delete"
    no_story_name: "This story has no name yet"
    recent_edit: "Recently Edited"
    completed: "Completion Status"
    search_placeholder: "Enter name to search"
    select_story_type: "Please select story type"
    select_perspective: "Please select writing perspective"
    menu_command_missing: "Menu option missing command property"
</i18n>


<template>
<div>
    <div style="padding: 1rem;background: #FAFAFD;transform: translate(0);padding-top: 2rem;">
      <div style="font-weight: 600;font-size: 20px;color: rgba(0,0,0,0.8);" class="">
          <div style="align-items: center;display: flex;">
            {{ $t('title') }}
          </div>
          <div style="font-size: 16px;color: rgba(36,36,36,0.5);">
            {{  }}
          </div>
      </div>
    </div>

    <!-- mywork search-->
    <div class="d-flex flex-between flex-y-center global-box-scrollbar"
         style="border-radius: 20px 0px 0px 0px;width: 100%; overflow: auto;
            scrollbar-width: none;
            -ms-overflow-style: none;
            overflow-x: scroll;overflow-y: hidden;">
      <div class="d-flex flex-between flex-y-center" style="width:100%;">
        <!-- left -->
        <div class="d-flex">
          <div class="ly-story-gen-type pointer" :style="{'background': genTypeActive==item.name?'#366EF4':'rgba(172,178,255,0.2)','color': genTypeActive==item.name?'#FFFFFF':'rgba(54,110,244,0.5)', 'font-weight': genTypeActive==item.name?'600':''}"
           style="padding: .6rem 1.5rem;margin: 0 .5rem 0 1rem;text-wrap: nowrap;
            border-radius: 20px;font-size: .8rem;"
                v-for="(item,index) in enums.ArticleGenTypeEnum"
                @click.stop="handlePage(1,item)"
                :key="index" >
                    {{item.desc}}
          </div>
        </div>
        <!-- right -->
        <div class="" style="text-wrap: nowrap;">
          <span style="margin-left: 0.5rem;" v-if="showStateFlag">
            <el-select style="width: 6rem;" class="custom-select"
                v-model="queryForm.articleState"
                filterable
                size="mini"
                :placeholder="$t('completed')">
              <el-option
                v-for="(item,index) in enums.ArticleStateEnum"
                @click.native.stop="handlePage()"
                :label="item.desc"
                :key="index"
                :value="item.name"
              />
            </el-select>
          </span>
          <span style="display: inline-block;margin-left: 0.5rem; ">
            <el-input suffix-icon="el-icon-search" class="search-title custom-select" v-model="queryForm.title" @input="handlePage()" :placeholder="$t('search_placeholder')" clearable>
            </el-input>
          </span>
        </div>
      </div>
    </div>

    <!-- mywork work -->
    <div class="writer-story-card-box" v-if="data.length>0" style="position: relative;">
      <el-card class="writer-story-card" style="position: relative;"
         v-for="(item,index) in data" :key="index"
          @click.native.stop="itemClick(item)">
            <div class="word-count-tail" :class="{'word-count-tail-dp': item.articleGenType == 'GEN_BY_ZHIHU' || item.articleGenType == 'GEN_BY_OUTLINE','word-count-tail-cdp': item.articleGenType == 'GEN_BY_IDEA' || item.articleGenType == 'GEN_BY_CHANGPIAN'}">
              {{ getTailByGenType(item) }}
            </div>
            <div class="writer-story-card-title-header d-flex" style="justify-content: space-between;margin-top: 1rem;">
              <div class="ellipsis2 writer-story-card-title d-flex-1" style="align-items: center; ">
                <img v-if="item.articleEventType === 'SIGN_OK'" style="width: 1rem;margin-right: 0.5rem;" src="@/assets/icon-home-submissioned.png" />
                <span v-if="item.title">{{ item.title }}</span>
                <span v-else style="color: #999;">{{$t('no_story_name')}}</span>
              </div>
            </div>
            <div class="d-flex" style="margin-top: .5rem;">
              <div style="background: #F1F2FF;border-radius: 20px;font-size: 12px;color: #366EF4;padding: .25rem .5rem;">{{item.articleGenTypeLabel}}</div>
              <div v-if="item.articleTypeVo && item.articleTypeVo.fieldLabel && item.articleTypeVo.fieldLabel != ''" style="margin-left:.5rem;background: #F1F2FF;border-radius: 20px;font-size: 12px;color: #366EF4;padding: .25rem .5rem;">{{item.articleTypeVo?item.articleTypeVo.fieldLabel:''}}</div>
              <div style="margin-left:.5rem;background: #F1F2FF;border-radius: 20px;font-size: 12px;padding: .25rem .5rem;" v-if="item.articleGenType!='GEN_BY_CHANGPIAN'" :style="{'color': item.articleState=='COMPLETED'?'#366EF4':'#A6A3A3'}">{{item.articleStateLabel}}</div>
              <div v-if="item.articleEventType === 'SIGN_OK'" style="margin-left:.5rem;background: #F1F2FF;border-radius: 20px;font-size: 12px;color: #366EF4;padding: .25rem .5rem;">{{$t('signed')}}</div>
            </div>
            <div class="" style="display: flex;align-items: center;justify-content: space-between;margin-top: .5rem;">
              <div class="writer-story-card-time">
                <span class="writer-story-card-time-label">{{$t('recent_edit')}}</span>
                <span>{{ $i18n.locale === 'zh' ? $time.formatTime(new Date(item.updateTime).getTime()) : $time.formatTimeEn(new Date(item.updateTime).getTime()) }}</span>
              </div>
              <div class="writer-story-card-menu">
                <el-dropdown @click.native.stop :trigger="isMobile ? 'click':'hover'" >
                  <span><img style="width: 1rem;" src="@/assets/writer-more.png" /></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <el-tooltip v-if="item.articleEventType === 'SIGN_OK'" @click.native.stop :content="$t('delete_signed_tip')" placement="top">
                        <div class="writer-story-card-menu-delete d-flex flex-y-center pointer">
                          <img style="width: .8rem;" src="@/assets/writer-delete.png"/>
                          <span>{{$t('delete')}}</span>
                        </div>
                      </el-tooltip>
                      <el-tooltip v-else-if="item.deliveryFlag" @click.native.stop :content="$t('delete_submitted_tip')" placement="top">
                        <div class="writer-story-card-menu-delete d-flex flex-y-center pointer">
                          <img style="width: .8rem;" src="@/assets/writer-delete.png"/>
                          <span>{{$t('delete')}}</span>
                        </div>
                      </el-tooltip>
                      <div v-else class="writer-story-card-menu-delete d-flex flex-y-center pointer" @click.stop="handleRemove(item)">
                        <img style="width: .8rem;" src="@/assets/writer-delete.png"/>
                        <span>{{$t('delete')}}</span>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
      </el-card>
    </div>
    <el-empty class="data-empty" v-else image="https://www.creatimix.com/static/empty.jpg" :description="$t('empty_desc')" style="margin: 0 auto;background-color: #FFFFFF;">
      <p style="margin: 0;color: rgba(0,0,0,0.6);font-size: 14px;">{{$t('empty_tip')}}</p>
    </el-empty>

    <el-row>
      <el-col>
        <div class="pagination">
          <el-pagination background
            hide-on-single-page
            :page-sizes="paginations.pages"
            :page-size="paginations.size"
            :layout="paginations.layout"
            :total="paginations.total"
            :current-page.sync="paginations.current"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </el-col>
    </el-row>

    <StoryIdeaDialog v-if="showDialogCdpFlag && storyTiaojian.length>0" :enums="enums" channel="workspace_index" />
    <Gen4Outline v-if="storyTiaojian.length>0" :enums="enums" channel="workspace_index" />
  </div>
</template>
<script>
import * as StoryTemplateApi from '@/api/storytemplate'
import * as EnumApi from '@/api/enums'
import * as ArticleApi from '@/api/article'
import * as EvaluationApi from '@/api/evaluation'
import * as CultureApi from '@/api/culture'
import * as StoryCpApi from '@/api/storycp'
import * as StorySynesthesiaElementApi from '@/api/storysynesthesiaelement'
import * as StoryHotApi from '@/api/storyhot'
import { mapState, mapMutations} from 'vuex'
import StoryIdeaDialog from '@/components/StoryIdeaDialog/index'
import Gen4Outline from '@/components/Gen4Outline'
import HomeBox from '@/components/homebox/box-create'
export default {
  name: 'MyWorks',
  components: {
    StoryIdeaDialog,Gen4Outline,HomeBox
  },
  data() {
    return {
      genTypeActive: '-1',
      fromType: 'writer_client',
      dialogShowGenbyoutline: false,
      showStateFlag: true,
      dialogShowGenbyidea: false,
      // enums: {"ArticleTypeEnum":[{"desc":"","name":""}]},
    	targetPermit: 'article',
      queryForm: {
        name: '',
        fromType: 'writer-web',
        articleGenType: '-1',
        articleGenTypes: [],
        articleState: '',
        current: '',
        size: 20
      },
      activeMenuItem: 1,
      synesthesiaElements:[],
      cps:[],
      hots:[],
      storyTemplates:[],
      dongtai: [],
      tougao: [],
      data: [],
      queryForm: {
        name: '',
        fromType: 'writer-web',
        articleGenType: '-1',
        articleGenTypes: [],
        articleState: '',
        current: '',
        size: 20
      },
      paginations: {
        current: 1, // 当前页
        total: 0, // 总行数
        size: 20, // 每页行数
        // sizes: [20], // 每页行数 调整
        layout: 'total, prev, pager, next' // 翻页属性
      }
    }
  },
  mounted() {
    this.setShowZhilingPanelFlag(false)
    this.setActiveMenuItem('2')
    this.handlePage()
    this.handleEnum()
    this.handleTemplatePage()
    this.setStoryContents([])
    this.handleMessage()
  },
  computed: {
  	...mapState(['user', 'story', 'showDialogCdpFlag','enums',
    'showDialogDpFlag', 'showGenbyoutlineFlag', 'storyTiaojian']),
    isMobile() {
      return window.innerWidth <= 768 ? true : false;
    }
  },
  methods: {
    gotoSubmissionLink(){
      // window.open('https://maliwriter.com/newsdetail/1946474338811432962', '_blank')
      window.open('https://maliwriter.com/newsdetail/1955463272530735106', '_blank')
    },
    ...mapMutations(['setActiveMenuItem','setStory','setStoryContents','setEnums',
    'setShowGenbyoutlineFlag', 'setShowDialogCdpFlag', 'setShowDialogDpFlag',
     'setShowChangpianDialogFlag', 'setActiveTemplate', 'setStoryTiaojian', 'setShowZhilingPanelFlag']),
    contentChange(item){
      console.log('contentChange', item);
    },
    getTailByGenType(item){
      let tail = ''
      if(item.articleGenType == 'GEN_BY_ZHIHU' || item.articleGenType == 'GEN_BY_OUTLINE'){
        tail = this.$i18n.locale === 'zh' ? '短篇小说' : 'Short Story'
      }else if(item.articleGenType == 'GEN_BY_IDEA'){
        tail = this.$i18n.locale === 'zh' ? '超短篇小说' : 'Mini Story'
      }else if(item.articleGenType == 'GEN_BY_CHANGPIAN'){
        tail = this.$i18n.locale === 'zh' ? '长篇小说' : 'Novel'
      }else{
        tail = ''
      }
      return tail;
    },
    handleTemplateClick(item) {
      // console.log(item);
      this.setActiveTemplate(item)
      let story = {id: ''}
      story.articleGenType = 'GEN_BY_ZHIHU'
      story.articleType = 'FEEL_GOOD'
      this.setStory(story)
      setTimeout(()=>{
        this.$router.push('/workspace/gen')
      }, 300)
    },
    handleTemplatePage(){
      StoryTemplateApi.page({
        templateType: 'GUANFANG',
        enableFlag: true,
        size: 6
      }).then(res => {
        let result = res.data.data;
        this.storyTemplates = result.records;
      });
    },
    handleGen(cmditem) {
      if (!cmditem) {
        this.$message.error(this.$t('menu_command_missing'))
        return
      }
      let story = {id: ''}
      switch (cmditem) {
        case 'genbyidea'://cdp
          // gen story
          story.articleGenType = 'GEN_BY_IDEA'
          story.articleType = 'TANBI_DOUBLE_BOY'
          this.setStory(story)
          this.setShowDialogCdpFlag(true)
          break
        case 'genbyoutline'://duanpian dingzhi
          // gen story
          story.articleGenType = 'GEN_BY_OUTLINE'
          story.articleType = 'FEEL_GOOD'
          story.articleStyle = 'ZHENGWEN'
          story.writingPerspective = 'FIRST_PERSON'
          this.setStory(story)
          this.setShowGenbyoutlineFlag(true)
          break
        case 'genbyzhihu'://dp
          story.articleGenType = 'GEN_BY_ZHIHU'
          story.articleType = 'FEEL_GOOD'
          this.setStory(story)
          this.$router.push({ path: '/workspace/gen'})
          break
        case 'genbychangpian'://changpian
          story.articleGenType = 'GEN_BY_CHANGPIAN'
          story.articleType = 'CP_YANQING'
          this.setStory(story)
          this.setShowChangpianDialogFlag(true)
          this.$router.push({ path: '/workspace/gencp'})
          break
        case 'chaishu':// chaishu
          this.$router.push({ path: '/bookbreakdown/index'})
          break
      }
    },
    newStoryByOutline() {
      if (!this.story.articleType || !this.story.articleType.trim()) {
          this.$message.error(this.$t('select_story_type'));
          return false;
      }

      if (!this.story.writingPerspective || !this.story.writingPerspective.trim()) {
          this.$message.error(this.$t('select_perspective'));
          return false;
      }
      // return false;
      ArticleApi.create(this.story).then(res => {
          if(res.data.code == 0){
            let data = res.data.data
            this.setStory(data)
            console.log('story', this.story);
            this.$router.push('/workspace/genbyoutline');
          }else{
            this.$message.error(res.data.msg);
          }
      })
    },
    handleRemove(item) {
      this.$confirm(this.$t('delete_confirm'),this.$t('confirm'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        customClass: 'custom-confirm',
        center: false
      }).then(() => {
        ArticleApi.remove(item.id).then(res => {
          this.handlePage();
        });
      }).catch((e) => {console.log('error', e)});
    },
    itemClick(item){
      this.setStory(item)
      setTimeout(()=>{
        if(!item.stepNumber || item.stepNumber == 0 || item.stepNumber == 1){
          if(this.story.articleGenType == 'GEN_BY_ZHIHU'){
              this.$router.push('/workspace/gen')
          }else if(this.story.articleGenType == 'GEN_BY_CHANGPIAN'){
            this.$router.push('/workspace/gencp')
          }else if(this.story.articleGenType == 'GEN_BY_IDEA'){
            this.$router.push('/workspace/genbyidea')
          }else if(this.story.articleGenType == 'GEN_BY_OUTLINE'){
            this.$router.push('/workspace/genbyoutline')
          }
        }else {
          if(this.story.articleGenType == 'GEN_BY_ZHIHU'){
            this.$router.push('/workspace/gen' + (item.stepNumber-1))
          }else if(this.story.articleGenType == 'GEN_BY_CHANGPIAN'){
            this.$router.push('/workspace/gencp')
          }else if(this.story.articleGenType == 'GEN_BY_IDEA'){
            this.$router.push('/workspace/genbyidea' + item.stepNumber)
          }else if(this.story.articleGenType == 'GEN_BY_OUTLINE'){
            this.$router.push('/workspace/genbyoutline' + item.stepNumber)
          }
        }
      }, 300)
    },
    handleEnum() {
      EnumApi.map().then(res => {
        let result = res.data.data;
        console.log('result', result);
        let tree = this.$buildTree(result, 0, 0)
        console.log('tree', tree);
        this.setStoryTiaojian(tree)
      })
      let that = this;
      EnumApi.list().then(res => {
        let result = res.data.data;
        result.ArticleStateEnum.unshift({name: '-1', desc: this.$t('all')})
        result.ArticleStateEnum.push({name: 'SIGN_OK', desc: this.$t('signed')})
        result.ArticleGenTypeEnum.shift()
        result.ArticleGenTypeEnum.unshift({name: '-1', desc: this.$t('all')})
        that.setEnums(result)
      })
    },
    handlePage(current, item) {

      let that = this;
      if (current) {
        that.paginations.current = current
      }
      that.queryForm.current = that.paginations.current
      that.queryForm.size = that.paginations.size

      console.log('workspace index user', this.user);
      if(!this.user || !this.user.id){
        return false;
      }
      if(item){
        that.queryForm.articleGenType = item.name
        this.genTypeActive = item.name
      }
      if(this.queryForm.articleGenType == 'GEN_BY_CHANGPIAN'){
        that.showStateFlag = false
        that.queryForm.articleState = ''
      }else{
        that.showStateFlag = true
      }
      that.queryForm.accountId = this.user.id

      if(this.queryForm.articleGenType == 'GEN_BY_ZHIHU'){
        this.queryForm.articleGenTypes = ['GEN_BY_ZHIHU', 'GEN_BY_OUTLINE']
      }else{
        this.queryForm.articleGenTypes = []
      }

      let params = Object.assign({},that.queryForm)
      if(this.queryForm.articleState == '-1'){
        params.articleState = ''
      }
      if(this.queryForm.articleGenType == '-1'){
        params.articleGenType = ''
      }
      params.articleGroup = 'STORY'

      if (this.queryForm.articleState == 'SIGN_OK') {
        params.articleEventType = 'SIGN_OK'
        delete params.articleState
      }

      // 获取表格数据
      ArticleApi.page(params).then(res => {
        let result = res.data.data;
        that.data = result.records
        that.paginations.total = Number(result.total)
        that.paginations.current = Number(result.current)
        that.paginations.size = Number(result.size)
      })
    },
    handleMessage() {
      CultureApi.page({size: 100}).then(res => {
        let result = res.data.data;
        this.dongtai = result.records
      })
      EvaluationApi.page({size: 100}).then(res => {
        let result = res.data.data;
        this.tougao = result.records
      })
    },
    handleCurrentChange(page) {
      // 切换页码
      this.paginations.current = page
      this.handlePage()
    },
    handleSizeChange(size) {
      // 切换size
      this.paginations.size = size
      this.size = size
      this.handlePage()
    }
  }
}
</script>

<style scoped lang="scss">
.layout {
  height: 100%;
}
.main {
  min-height: 1px;
  flex: 1;
}
.el-aside {
  padding: 0px;
  margin-bottom: 0 !important;
  height: 100%;
  width: 17rem !important;
}
.el-scrollbar {
  height: 100%;
  background-color: #ffffff;
}
.el-header {
  padding: 0px !important;
  background-color: #001A40;
}
.el-main {
  height: 100%;
  overflow: hidden; /* 禁止父容器滚动 */
}
.dialog-container {
  background: #F4F5F9;
  border-radius: 20px;
  height: calc( 100% - 1rem );
  margin: 0 1rem 1rem;
  margin-bottom: 1rem;
  padding:1rem;
  overflow: auto;
}
.el-drawer.rtl {
    right: 0;
    overflow-y: auto !important;
}
/deep/ .el-card {
    border: 0;
    overflow-y: hidden !important;
}
/deep/ .el-empty__image img {
  margin-top: 20px;
}
.custom-select {
    /deep/ .el-input__inner {
      border-radius: 20px;
      height: 2.3rem;
      line-height: 2.3rem;
    }
    /deep/ .el-input__suffix {
      height: 2.3rem;
      line-height: 2.3rem;
      font-size: 12px;
      display: flex;
      align-items: center;
    }
}

/deep/ .el-carousel__item {
  white-space: nowrap;
  overflow: hidden;        /* 隐藏超出元素盒子的内容 */
  text-overflow: ellipsis; /* 显示省略号(...) */
}
.search-title {
  /deep/ .el-input__inner {
    height: 2.3rem;
    line-height: 2.3rem;
    font-size: 12px;
  }
  /deep/ .el-input__suffix {
    height: 2.3rem;
    line-height: 2.3rem;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
}
.el-input__inner .el-input__inner:hover {
    /deep/ {
      // border-color: transparent; /* 边框颜色设置为透明 */
      // border: none;
      // outline: none;
    }
}
// .writer-home-card-box
// .ly-story-gen-type:hover {
//   color: #366EF4 !important;
// }

.writer-home-card-box{
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
}
.writer-home-card {
  flex: 1;
  cursor: pointer;
  // border: 1px solid red;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
  border-radius: 14px;
  box-sizing: border-box; /* 边框计算在宽度内 */
  &-title-en {
    font-weight: 400;
    font-size: 14px;
    color: rgba(255,255,255,.8);
    line-height: 22px;
    border-radius: 20px;
    display: inline-block;
    padding: .1rem 1rem;
  }
  &-title {
    font-weight: 600;
    font-size: 28px;
    color: rgba(0,0,0,0.9);
    margin: 1rem 0;
  }
  &-top {
    display: flex;
    justify-content: space-between;
    &-img {
      width: 7rem;
      margin-top:  -.7rem;
    }
  }
  &-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
    &-img {
      width: 1rem;
    }
  }
  &-up {
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.4);
    line-height: 22px;
    display: flex;
    align-items: flex-start; /* 顶部对齐 */
    &-icon {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      color: #2BA471;
      line-height: 1rem;
      margin-right: .5rem;
      border-radius: 3px;
      padding: .25rem .5rem;
      &-img {
        width: 1rem;
      }
    }
  }
}
.writer-home-card-box > :nth-child(1) {
  background-image: url('../../assets/writer-edit2.png'), linear-gradient( 151deg, rgba(125,174,255,0.6) 0%, rgba(148,255,197,0.3) 50%, rgba(172,195,255,0.1) 100%);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right top;
  // background-image: ;
}
.writer-home-card-box > :nth-child(2) {
  background-image: url('../../assets/writer-light2.png'), linear-gradient( 137deg, rgba(137,150,255,0.6) 0%, rgba(235,210,255,0.6) 45%, rgba(144,126,255,0.04) 100%);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right top;
}
.writer-home-card-box > :nth-child(3) {
  background-image: url('../../assets/writer-changpian.png'), linear-gradient( 314deg, #FFECA8 0%, #FFFEDE 50%, #FFD4AC 100%);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right top;
}
.word-count-tail {
  border-radius: 6px 0px 20px 0px;
  width: auto; /* 默认值，但明确设置有助于理解 */
  white-space: nowrap; /* 防止文本换行 */
  display: inline-block;
  padding: .25rem 1.5rem .25rem 1rem;
  // font-weight: 600;
  font-size: 14px;
  position: absolute;
  top: 0;
  left: 0;
  &-cdp{
    background: linear-gradient( 90deg, #DAE1FF 0%, #F2F3FE 100%);
    color: #0052D9;
  }
  &-dp{
    background: linear-gradient( 90deg, #DAE1FF 0%, #F6F2FE 100%);
    color: #4043FF;
  }
  &-cp{
    background: linear-gradient( 90deg, #FFE9BC 0%, #FFF7DC 100%);
    color: #FD733B;
  }
}
.data-empty {
  background: #FFFFFF;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.1);
  border-radius: 0px 20px 20px 20px;
  padding: 1rem;
}
/deep/ .el-empty {
  min-height: 30vh !important;
}
/deep/ .el-empty__bottom {
  margin-top: 10px;
}

.writer-story-card-box {
  width: 100%;
  min-height: 400px;
  // background: #F4F5F9;
  // box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.1);
  // background: #F4F5F9;
  // border-radius: 0px 20px 20px 20px;
  padding: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
  grid-auto-rows: 10px;
  margin-bottom: 10px;
}

/deep/ .el-card.is-always-shadow {
  box-shadow: none !important;
}
/deep/ .el-card.is-always-shadow:hover {
  box-shadow: 4px 4px 15px 0 rgba(54, 110, 244, .2) !important;
}
.writer-story-card:hover{
  box-shadow: 4px 4px 15px 0 rgba(54, 110, 244, .2) !important;
}
.writer-story-card {
  cursor: pointer;
  width: 100%;
  box-shadow: none;
  max-width: 400px;
  box-sizing: border-box; /* 边框计算在宽度内 */
  border-radius: 6px;
  grid-row-end: span 7;
  &-title {
    font-weight: 600;
    font-size: 1rem;
    color: rgba(0,0,0,0.9);
    height: 3rem;
    line-height: 1.5rem;
  }
  &-time {
    // font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.3);
    line-height: 22px;
    &-label {
      margin-right: .5rem;
    }
  }
  &-menu {
    &-delete {
      // padding: .5rem;
      img {
        margin-right: .5rem;
      }
      // background: #F2F3FF;
      border-radius: 3px;
      color: #0052D9;
      font-size: .8rem;
    }
  }
}
/* 假设你的菜单类名为 .my-menu */
/deep/ .el-menu-agent .el-menu-item {
  border-radius: 6px !important;
  margin: 0 1rem 6px;
  height: 2.5rem;
  line-height: 2.5rem;
}
/deep/ .el-menu-agent .el-menu-item:hover {
  background-color: #4B4B4B !important;
}
.el-menu-agent .el-menu-item.is-active {
  background-color: #0252D9 !important; /* 激活状态下的背景颜色 */
}
/deep/ .writer-story-card-menu-delete .el-dropdown-item {
  background-color: transparent !important;
}
/deep/ .writer-story-card-menu-delete .el-dropdown-item:hover {
  background-color: transparent !important;
}

@media screen and (min-width: 500px) {
  .writer-home-card-box {
      grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  }
  /deep/ .custom-dialog .el-dialog {
    width: 60%;
  }
}
.news-box {
  display: flex;
  margin-bottom: 1rem;
  &-pc{
    justify-content: space-between;
  }
  &-mobile{
    flex-direction: column;
  }
  &-last {
    background: #FFFFFF;
    border-radius: 50px 50px 50px 50px;
    box-shadow: 2px 2px 10px 0px rgba(54,110,244,0.07);
    display: flex;
    align-items: center;
    padding: 0 1rem 0 .25rem;
    &-pc{
      flex: 1;
      margin-right: 1rem;
    }
    &-mobile{
      margin-bottom: 1rem;
    }
    &-title {
      color: #366EF4;
      font-weight: 600;
      line-height: 24px;
      font-size: 16px;
      margin-left: 10px;
    }
    &-content {
      margin-left: 1rem;
      color: #242424;
      flex: 1;
      font-size: 14px;
    }
  }
  &-contribute {
    background: #FFFFFF;
    border-radius: 50px 50px 50px 50px;
    box-shadow: 2px 2px 10px 0px rgba(54,110,244,0.07);
    display: flex;
    align-items: center;
    padding: 0 1rem 0 .25rem;
    width: 380px;
    &-title {
      color: #366EF4;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      text-wrap: nowrap;
      margin-left: 10px;
    }
    &-content {
      margin-left: 1rem;
      color: #366EF4;
      font-size: 14px;
    }
  }
}
/* 小屏下的样式 */
@media (max-width: 767px) {
  .news-box-contribute {
    width: 100% !important;
  }
}
// mly end
</style>

<style>
.custom-carousel {
  position: relative;
  width: 100%;
}

.custom-carousel .el-carousel__indicators--vertical {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.custom-carousel .el-carousel__indicator--vertical {
  margin: 5px 0;
}

.custom-carousel .el-carousel__indicator button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, .6);
  border: 1px solid rgba(255, 255, 255, .6);
  opacity: 0.5;
}

.custom-carousel .el-carousel__indicator--vertical.is-active button {
  background-color: #647EFF;
  border-color: #647EFF;
  opacity: 1;
}

</style>
